export const GET_ALL_BOOKS = 'GET_ALL_BOOKS';
export const SAVE_BOOK = 'SAVE_BOOK';
export const DELETE_BOOK = 'DELETE_BOOK';
export const LOADING = 'LOADING';
export const SEARCH_RESULTS = 'SEARCH_RESULTS';
export const CLEAR_RESULTS = 'CLEAR_RESULTS';
export const SORT_SAVED= 'SORT_SAVED';
export const STARTING_SEARCH= 'STARTING_SEARCH';
export const FINISHING_SEARCH= 'FINISHING_SEARCH';
export const FINISHED_SEARCH= 'FINISHED_SEARCH';





